// extracted by mini-css-extract-plugin
module.exports = {"configBox":"ExchangePairConfigs_configBox__2TeCq","configs":"ExchangePairConfigs_configs__3q-Ss","configItem":"ExchangePairConfigs_configItem__2LzWJ"};